'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResponseRow = undefined;

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResponseRow = exports.ResponseRow = undefined;

exports.ResponseRow = ResponseRow = function ResponseRow(refs, config) {
    var t = (0, _arrayFrom2.default)(config);

    t.getAt = function (index) {
        return this[index];
    };

    t.setIdCombination = function (idCombination) {
        t.idCombination = idCombination;
    };

    t.getNames = function (response, ignoreIndexes) {
        if (!t.idCombination) {
            t.setIdCombination(new refs.api.ResponseRowIdCombination(refs, t));
        }

        return t.idCombination.getNames(response, ignoreIndexes);
    };

    t.toFloat = function (index) {
        t[index] = parseFloat(t[index]);
    };

    t.getRowHtml = function (response, trClass, tdClass, ignoreIndexes) {
        trClass = trClass ? ' class="' + trClass + '"' : '';
        tdClass = tdClass ? ' class="' + tdClass + '"' : '';

        var tdStyle = ' style="padding:0 5px"';

        return '<tr' + trClass + '>' + t.getNames(response, ignoreIndexes).map(function (name) {
            return '<td' + tdClass + tdStyle + '>' + name + '</td>';
        }).join('') + '</tr>';
    };

    // uninitialized
    t.idCombination;

    return t;
};
//# sourceMappingURL=ResponseRow.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/ResponseRow.js
 ** module id = 127
 ** module chunks = 0 1
 **/